(function($, $document) {
	var moveWithKeys = function(e) {
		var keyCode = e.keyCode;

		if ( -1 === [38,40].indexOf(keyCode) ) {
			return true;
		}

		var $this = $(this);
		var $devices = $this.find('.compat-devices');
		var $hints = $devices.find('ul li');

		if ( ! $hints.length ) {
			return true;
		}

		var $activeElem = $devices.find('.active');

		if ( ! $activeElem.length ) {
			$devices.find('li:first').addClass('active');
			return true;
		}

		if ( 38 === keyCode ) {
			if ( $activeElem.prev('li').length ) {
				$activeElem.removeClass('active').prev('li').addClass('active');
			}
		} else if ( 40 === keyCode ) {
			if ( $activeElem.next('li').length ) {
				$activeElem.removeClass('active').next('li').addClass('active');
			}
		}

		$devices.stop().animate({scrollTop:$devices.find('.active')[0].offsetTop}, 100);
	}

	var inputTimer = null;
	$document.on('input', '.device-name', function() {
		var $this = $(this);
		var $form = $this.closest('form');
		var $compatDevices = $form.find('.compat-devices');
		$form.find('.compat-result').hide();

		if ( ! this.value ) {
			$compatDevices.html('').hide();
			return true;
		}

		var value = this.value;

		clearTimeout(inputTimer);
		inputTimer = setTimeout(function() {
			$.get(RSA.ajaxurl,
				{
					action: 'rsa_find_devices',
					model: value,
					nonce: RSA.nonce,
				}, function(response) {
				if ( response ) {
					$compatDevices.show().html(response);
				} else {
					$compatDevices.hide().html('');
				}
			}, 'html');
		}, 500);
	});
	$document.on('submit', '.find-device', function(e) {
		e.preventDefault();
		return false;
	});
	$document.on('keyup', '.find-device', moveWithKeys);
	$document.on('click', '.compat-devices li', function() {
		const $form = $(this).closest('form');
		$form.find('.device-name').val($(this).text());
		$form.find('.compat-devices').hide().html('');
		$form.find('.compat-result').show();
	});
})(jQuery, jQuery(document));
